<template>
<section id="iq-news" class="s-margin">
  <b-container fluid>
    <b-row>
      <b-col sm="12" class="overflow-hidden">
          <div class="iq-main-header d-flex align-items-center justify-content-between">
            <h3 class="main-title" v-b-tooltip.hover title="">
              Latest News
            </h3>
             <router-link :to="{ name: 'landing-page.channels' }" class="iq-view-all"></router-link>
          </div>
          <div>
            <Slick class="favorites-slider list-inline row p-0 mb-0" ref="dSlick" :option="sliderOption">
                <li class="slide-item" v-for="(item,index) in newsItems" :key="index">
                  <b-card no class="iq-card iq-card-block iq-card-stretch iq-card-height iq-mb-3">
                    <b-row no-gutters>
                      <b-col md="4" lg="4" xl="2">
						  <div style="line-height:140%;">
							  <br>
						  </div>
                        <b-card-img :src="item.image.url"></b-card-img>
                      </b-col>
                      <b-col md="8" lg="8" xl="10">
                        <b-card-body class="iq-card-body" :title="item.title" >
                          <b-card-text>
                            {{item.summary}}
                          </b-card-text>
                        </b-card-body>
                        <b-card-footer>
                          <b-card-text>
                          <small class="text-muted mt-0">{{item.date}}</small>
						   <router-link  :to="{name: 'News', params: { id: item.shorttitle, image: item.image.url, text:item.text.html, title:item.title, summary:item.summary, date:item.date },}">
										<div> <a> <h6 style="color:#FFD700"> Read Full Announcement </h6> </a> </div>
                            </router-link>
                          <!-- <a :href="item.release.url" target="_blank"><div id="link-to-pdf">Read full announcement</div></a> -->
                          </b-card-text>
                        </b-card-footer>
                      </b-col>
                    </b-row>
                  </b-card>
                </li>
            </Slick>
          </div>
      </b-col>
    </b-row>
  </b-container>
</section>
</template>
<script>

export default {
  name: 'news',
  props: {
    newsItems: Array
  },
  mounted () {
  },
  data () {
    return {
      sliderOption: {
        dots: false,
        arrows: true,
        infinite: true,
        speed: 2500,
        autoplaySpeed: 5000,
        autoplay: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<div class="slick-prev slick-arrow"><i class="fa fa-chevron-left"></i></div>',
        nextArrow: '<div class="slick-next slick-arrow"><i class="fa fa-chevron-right"></i></div>',
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      }
    }
  },
  methods: {
    next () {
      this.$refs.dSlick.next()
    },
    prev () {
      this.$refs.dSlick.prev()
    }
  }
}
</script>
<style scoped>
 h6{
   color: var(--iq-primary) !important;
 }
</style>
